<!-- blogposts-->
<div id="blogpost">
    <router-outlet></router-outlet>

    <!-- sidebar-->
    <div id="sidebar" class="padded">
        <section class="sidebar-intro">
            <img
                class="sidebar-photo"
                src="/assets/images/mainpic-300.jpg"
                srcset="
                    /assets/images/mainpic-300.jpg 300w,
                    /assets/images/mainpic-600.jpg 600w"
                sizes="120px"
                alt="Stephen Fluin"
                width="960"
                height="960"
                loading="lazy"
                decoding="async"
            />
            <div>
                <p>Thank you for stopping by!</p>
            </div>
        </section>

        <hr />
        <section id="social">
            <social-links />
        </section>

        <hr />

        @if (tags().length) {
        <section id="tag-list" aria-labelledby="tags-heading">
            <h2 id="tags-heading" class="sidebar-heading">Topics</h2>
            <ul class="tag-cloud">
                @for (tag of tags(); track tag.slug) {
                <li>
                    <a routerLink="/blog" [queryParams]="{ tag: tag.slug }">{{ tag.name }} <span class="tag-count">{{ tag.count }}</span></a>
                </li>
                }
            </ul>
        </section>

        <hr />
        }

        <section id="featured-blogs" aria-labelledby="featured-posts-heading">
            <h2 id="featured-posts-heading" class="sidebar-heading">Featured posts</h2>
            @for (post of posts(); track post.key) {
            <a [routerLink]="['/blog', post.id]" class="featured-blog card">
                <img
                    class="featured-blog-image"
                    [src]="featuredPostImage(post)"
                    [attr.srcset]="featuredPostImageSet(post)"
                    [sizes]="featuredImageSizes"
                    alt=""
                    width="240"
                    height="150"
                    loading="lazy"
                    decoding="async"
                />
                <div class="featured-blog-details">
                    <h3>{{ post.title }}</h3>
                    <p>Read More -></p>
                </div>
            </a>
            }
        </section>
        <!-- end featured-blogs-->
    </div>
</div>
